import DashboardFetchWrapper from "@/components/Templates/DashboardFetchWrapper";
import { DashboardTemplate } from "@/components/Templates/DashboardTemplate";
import { OverviewCards } from "./Cards";
import PageHeader from "@/components/UI/PageHeader";
import { useScopeParams } from "@/hooks/useScopeParams";

export default function Overview() {
  const { id } = useScopeParams();
  return (
    <div className="w-full p-4">
      <div className="flex items-center justify-between mb-4">
        <PageHeader
          title="Subjects: Participant Profiles"
          tooltipText="A comprehensive view of all subjects in your trial. Review their demographics, study statuses, and other information."
          dataTestId="subjects-subject-profiles"
        />
      </div>
      <div className="flex flex-col gap-4">
        {/* Outside the wrapper on purpose: it spins until the table's filter
            metadata lands (~660ms on demo), and the cards don't need it. */}
        <OverviewCards />
        <DashboardFetchWrapper datasetName="subjects_overview">
          {({ metadata, workspace }) => (
            <DashboardTemplate
              metadata={metadata}
              datasetName="subjects_overview"
              constants={{
                wikiLink: "/wiki/guides/subjects-overview",
                idLink: `/${id}/subjects/overview`,
              }}
              workspace={workspace}
            />
          )}
        </DashboardFetchWrapper>
      </div>
    </div>
  );
}
